import React from 'react'
import { useTranslation } from 'react-i18next'
import { DetailsCard } from '@node-space/storybook-components/dist/DetailsCard'
import { Avatar, Box, Text } from '@node-space/ui-components'
import { CustomerEntityType } from 'types/customers'
import { CustomerDetails } from '../types'

interface CustomerInfoProps {
  customerDetails: CustomerDetails
}

const CustomerInfo = ({ customerDetails }: CustomerInfoProps) => {
  const { t } = useTranslation()

  return (
    <>
      <Box flexCol padding={16} gap={32}>
        <Text tag="h2" variant="heading-2">
          {customerDetails?.type == CustomerEntityType.COMPANY && t('customers.companyInfo')}
          {customerDetails?.type == CustomerEntityType.INDIVIDUAL && t('customers.individualInfo')}
        </Text>
        <Box flexCol align="center" gapY={12}>
          {customerDetails?.name && (
            <Avatar size="large" type="entity" name={customerDetails?.name || ''} />
          )}
          <Text tag="h3" variant="heading-3" isCentered>
            {customerDetails?.name}
          </Text>
        </Box>
      </Box>
      {customerDetails?.details && (
        <DetailsCard
          borderless
          background="white"
          details={Object.keys(customerDetails?.details)
            ?.filter(key => !!customerDetails?.details?.[key]?.trim())
            ?.map(key => ({
              value: customerDetails?.details?.[key],
              label: t(`customers.${key}`),
            }))}
        />
      )}
    </>
  )
}

export default CustomerInfo
